import './../Filter/Filter.scss';
import Component from './AgentListFilter.js';
export default Component;